import clsx from 'clsx'
import { HomeIcon, InviteIcon, MeIcon, TeamIcon } from './TabBarIcons'

/**
 * TabBar 组件
 * 基于 Figma 设计图重构，包含 Home, Invite, Team, Me 四个标签
 *
 * @param props {Object}
 * @param props.activeTab {string} 当前激活的标签
 * @param props.onTabChange {Function} 标签切换回调
 */
export default function TabBar(props: {
  activeTab: 'home' | 'team' | 'invite' | 'me'
  onTabChange: (tab: 'home' | 'team' | 'invite' | 'me') => void
}) {
  // 定义标签项
  const tabs = [
    { id: 'home', label: 'Home', Icon: HomeIcon },
    { id: 'invite', label: 'Invite', Icon: InviteIcon },
    { id: 'team', label: 'Team', Icon: TeamIcon },
    { id: 'me', label: 'Me', Icon: MeIcon },
  ] as const

  return (
    <nav
      className='bg-white relative flex h-[49px] w-full items-center justify-center gap-[66px] py-[6px] shadow-[0px_-0.5px_0px_0px_rgba(0,0,0,0.1)]'
      data-testid='tab-bar'
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => props.onTabChange(tab.id)}
          className='flex flex-col items-center justify-center relative shrink-0 w-[28px]'
          data-testid={`tab-${tab.id}`}
          role='tab'
          aria-selected={props.activeTab === tab.id}
        >
          {/* 图标容器 */}
          <div className='flex h-[24px] w-[24px] items-center justify-center p-px relative shrink-0'>
            <tab.Icon active={props.activeTab === tab.id} />
          </div>
          {/* 标签文字 */}
          <span
            className={clsx(
              'font-semibold text-[10px] leading-normal text-center w-full mt-[2px]',
              props.activeTab === tab.id ? 'text-[#8162da]' : 'text-[#c0c7d1]',
            )}
          >
            {tab.label}
          </span>
        </button>
      ))}
    </nav>
  )
}
